import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/simple.svg'


const _hoisted_1 = { class: "navbar sticky-top navbar-expand white navbar-light header-nav" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "navbar-brand",
  href: "#",
  style: {"margin-left":"50px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto" }, null, -1)
const _hoisted_5 = { class: "navbar-nav header-ul" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Resultater")
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Informasjon")
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Påmelding")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          width: "275",
          class: "header-img",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.home && _ctx.home(...args)))
        })
      ]),
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/info",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/registration",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}